import {
  AGREEMENT_TYPE,
  IAgreementTemplatetAggregator,
  IAgreementTemplatetAggregatorForm,
} from 'services/templates/agreement-template/types';

export const agreementTemplateFormToQuery = (
  agreement: IAgreementTemplatetAggregatorForm,
  position = 0,
  update = true
): IAgreementTemplatetAggregator => {
  const {
    selectAgreementTemplate,
    textAgreementTemplate,
    paragraphAgreementTemplate,
    type,
  } = agreement;

  const agreementDefaultProperties = { position, update, mode: 1 };

  if (type === AGREEMENT_TYPE.text && textAgreementTemplate) {
    return {
      selectAgreementTemplate: null,
      textAgreementTemplate: {
        ...textAgreementTemplate,
        ...agreementDefaultProperties,
      },
    };
  }

  if (type === AGREEMENT_TYPE.select && selectAgreementTemplate) {
    return {
      textAgreementTemplate: null,
      selectAgreementTemplate: {
        ...selectAgreementTemplate,
        ...agreementDefaultProperties,
      },
    };
  }

  if (type === AGREEMENT_TYPE.paragraph && paragraphAgreementTemplate) {
    return {
      selectAgreementTemplate: null,
      textAgreementTemplate: {
        ...paragraphAgreementTemplate,
        ...agreementDefaultProperties,
      },
    };
  }

  return {
    textAgreementTemplate: null,
    selectAgreementTemplate: null,
  };
};
